import React, { useState, useEffect, useRef } from 'react';
import './Home.css';
import Projects from '../../components/projects/Projects';
import Hero from '../../components/hero/Hero';
import Loader from '../../components/loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { setAllProjects, setDisplayProjects, setHeaderMainLink, setFilterChoices } from '../../services/store/GenericReducer';
import { isMobile } from 'react-device-detect';
import BannerCard from '../../components/banner-card/BannerCard';
import BottomBanner from '../../components/bottom-banner/BottomBanner';
import GlobalTexts from '../../components/global/GlobalTexts';
import GlobalOrganizationsProjects from '../../components/global/GlobalOrganizationsProjects';
import { filterProjects, sortProjectsByDisplayOrder } from '../../services/filters/filters';
import { getFiltersFromUrl, mergeFiltersWithUrl, updateUrlWithFilters, hasUrlFilters } from '../../utils/urlFilters';

export default function Home(props) {

  const store = useSelector(state => state.reducer)
  const [projects, setProjects] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [filtersArray,setFiltersArray] = useState(props.partner.partnerConfig.filterTypes);
  const partnerColor = props.partner.partnerConfig.leadingColor;
  const dispatch = useDispatch();

  const getProjects = async() => {
    setSearchLoader(true)

    try{
      let organizationsProjects = await GlobalOrganizationsProjects()
      let projects = organizationsProjects.projects
      if (projects && projects.length > 0) {
        // Filter only projects that can be published on website
        //const publishableProjects = projects.filter(project => project.attributes?.canPublishOnWebsite === true)
        const publishableProjects = projects
        setProjects(publishableProjects)
        dispatch(setAllProjects(publishableProjects))
        // Apply default sorting order on first load
        const sortedProjects = sortProjectsByDisplayOrder(publishableProjects)
        dispatch(setDisplayProjects(sortedProjects))
      }
    }catch(error){
      console.log('error', error)
      dispatch(setDisplayProjects([]))
    }
    setSearchLoader(false)
  }

  // Apply filters when allProjects is loaded and there are active filters
  useEffect(() => {
    if (store.allProjects?.length > 0 && store.filterChoices) {
      // Check if there are active filters
      const hasActiveFilters = Object.values(store.filterChoices).some(filter => filter?.choice);
      if (hasActiveFilters) {
        filterProjects(store, dispatch);
      }
    }
  }, [store.allProjects])

  let finalMount = useRef(true)
  useEffect(() => {
    if(finalMount.current){
      finalMount.current = false

      // Check for URL filters first (priority over localStorage)
      const urlFilters = getFiltersFromUrl()
      if (urlFilters) {
        // URL has filters - merge with existing and apply
        const mergedFilters = mergeFiltersWithUrl(store.filterChoices, urlFilters)
        dispatch(setFilterChoices(mergedFilters))
      } else if (store.filterChoices) {
        // No URL filters, but we have localStorage filters - update URL
        const hasActiveFilters = Object.values(store.filterChoices).some(filter => filter?.choice)
        if (hasActiveFilters) {
          updateUrlWithFilters(store.filterChoices)
        }
      }

      getProjects()
      dispatch(setHeaderMainLink(false))
    }
  }, [])

  return (
    <>
      <div id="main" role="main">

          <Hero partner={props.partner} filters={filtersArray}/>

          <Loader showLoader={searchLoader} color={partnerColor}/>
          
          <Projects partner={props.partner} leadingColor={partnerColor} projects={store.displayProjects}/>
          
          {isMobile && (
            <BannerCard
                leadingColor={partnerColor}
                banner_img_src={props.partner.partnerConfig.adImageUrl}
                banner_img_alt={props.partner.partnerConfig.adMessageAltText}
                banner_title={props.partner.partnerConfig.adMessage}
                banner_content={props.partner.partnerConfig.adMessageSubTitle}
            />)}

          {isMobile && <BottomBanner />}

          {!isMobile && (
            <div className="back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              בחזרה לראש העמוד
            </div>
          )}
      </div>
    </>
  )
}
